export default "__VITE_ASSET__C7y3o6Vc__"